const getDistricts = () => {
  const districts = localStorage.getItem("districts")
    ? JSON.parse(localStorage.getItem("districts"))
    : null;

  if (districts) return districts;

  return null;
};

const InitialState = {
  districts: getDistricts(),
};

const DistrictsDataReducer = (state = InitialState, action) => {
  if (action.type === "Save_Districts_Data") {
    const newState = {
      districts: action.payload,
    };

    localStorage.setItem("districts", JSON.stringify(action.payload));

    return newState;
  }

  return state;
};

export default DistrictsDataReducer;
